import service from "@/store/services/special-order-reservations-service";

export const state = () => ({
  list: [],
  reservation: {},
  meta: {},
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, reservation) => {
    state.reservation = reservation;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((reservation) => {
      commit("SET_RESOURCE", reservation);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta?.page?.total ?? 0,
  reservation: (state) => state.reservation,
};

const specialOrderReservations = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default specialOrderReservations;
